import {Backbone} from 'Vertebrae';
import {Service} from '../model/service';

export const Services = Backbone.Collection.extend({
    _name: 'VerticalServices',
    model: Service,
});
